const singleRelatedSwiper = new Swiper(".swiper.swiper--single-related-projects", {
	// Optional parameters
	loop: document.querySelectorAll(".swiper.swiper--single-related-projects .swiper-slide").length != 1,
	slidesPerView: 1,
	lazy: true,
	simulateTouch: false,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},

	autoplay: {
		delay: 5000
	},
	speed: 700,

	// If we need pagination
	pagination: false,

	// Navigation arrows
	navigation: {
		nextEl: ".swiper.swiper--single-related-projects .swiper-button-next",
		prevEl: ".swiper.swiper--single-related-projects .swiper-button-prev",
	},
});
